import React from 'react';

const VideoPlayIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.7295 2H9.26953V6.36H14.7295V2Z" fill="#9AA2AC" />
    <path d="M16.2305 2V6.36H21.8705C21.3605 3.61 19.3305 2.01 16.2305 2Z" fill="#9AA2AC" />
    <path
      d="M2 7.86011V16.1901C2 19.8301 4.17 22.0001 7.81 22.0001H16.19C19.83 22.0001 22 19.8301 22 16.1901V7.86011H2ZM14.44 16.1801L12.36 17.3801C11.92 17.6301 11.49 17.7601 11.09 17.7601C10.79 17.7601 10.52 17.6901 10.27 17.5501C9.69 17.2201 9.37 16.5401 9.37 15.6601V13.2601C9.37 12.3801 9.69 11.7001 10.27 11.3701C10.85 11.0301 11.59 11.0901 12.36 11.5401L14.44 12.7401C15.21 13.1801 15.63 13.8001 15.63 14.4701C15.63 15.1401 15.2 15.7301 14.44 16.1801Z"
      fill="#9AA2AC"
    />
    <path d="M7.76891 2C4.66891 2.01 2.63891 3.61 2.12891 6.36H7.76891V2Z" fill="#9AA2AC" />
  </svg>
);

export default VideoPlayIcon;
